import React, { FC, useCallback } from 'react'

import { RewardsQuery } from '../../../../../../../graphql/search'
import { setTierBenefitsModalState } from '../../../../../../../lib/rewards/tier-benefits-modal'
import { RewardsCardHeader } from '../../../RewardsCard'
import { RewardsHeading4 } from '../../../RewardsHeading'
import { RewardsInformationTooltip } from '../../../RewardsInformationTooltip'
import { RewardsLinkButton } from '../../../RewardsLink'
import { TierDetailsCard } from '../TierDetailsCard'
import { TierProgressBar } from '../TierProgressBar'
import * as Styled from './styled'

interface MonthlyRewardsProgressProps {
  currentSnapshot?: NonNullable<
    NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
  >['nodes'][number]
}

export const MonthlyRewardsProgress: FC<MonthlyRewardsProgressProps> = ({ currentSnapshot }) => {
  const openTierBenefitsModal = useCallback(() => setTierBenefitsModalState({ isOpen: true }), [])

  return (
    <Styled.Container>
      <RewardsCardHeader>
        <RewardsHeading4>
          Monthly Rewards Progress
          <RewardsInformationTooltip>
            Sales and purchases through the month contribute to Rewards, which are determined
            according to the Tier achieved at the end of the month. VIP Discount is applicable to
            next month&apos;s sales.
          </RewardsInformationTooltip>
        </RewardsHeading4>
        <Styled.HeaderActions>
          <RewardsLinkButton onClick={openTierBenefitsModal}>View Tier Benefits</RewardsLinkButton>
        </Styled.HeaderActions>
      </RewardsCardHeader>
      <TierProgressBar currentSnapshot={currentSnapshot} />
      <TierDetailsCard currentSnapshot={currentSnapshot} />
    </Styled.Container>
  )
}
